<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent top-navbar"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute
    }"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <!--        {{ $route.meta.title }}-->
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <md-list>
            <!--            <li class="md-list-item">-->
            <!--              <a-->
            <!--                href="javascript:void(0)"-->
            <!--                class="md-list-item-router md-list-item-container md-button-clean dropdown"-->
            <!--              >-->
            <!--                <div class="md-list-item-content">-->
            <!--                  <drop-down id="notification-list-top-navbar" direction="down">-->
            <!--                    <md-button-->
            <!--                      slot="title"-->
            <!--                      class="md-button md-just-icon md-simple"-->
            <!--                      data-toggle="dropdown"-->
            <!--                    >-->
            <!--                      <md-icon>notifications</md-icon>-->
            <!--                      <span class="notification">0</span>-->
            <!--                      <p class="hidden-lg hidden-md">Notifications</p>-->
            <!--                    </md-button>-->
            <!--                    <ul-->
            <!--                      class="dropdown-menu dropdown-menu-right notification-button custom-scrollbar"-->
            <!--                    >-->
            <!--                      <li>-->
            <!--                        <router-link-->
            <!--                          class="all-notification"-->
            <!--                          :to="{-->
            <!--                            name: 'ProfileUser'-->
            <!--                          }"-->
            <!--                        >-->
            <!--                          {{ $t("common.notification") }}-->
            <!--                        </router-link>-->
            <!--                      </li>-->
            <!--                      <li-->
            <!--                        class="item-notification"-->
            <!--                        v-for="(notification, $index) in notifications"-->
            <!--                        :key="'top-navbar-notification-' + notification.id"-->
            <!--                        :data-num="$index + 1"-->
            <!--                      >-->
            <!--                        <a-->
            <!--                          href="javascript:void(0)"-->
            <!--                          class="notification-box"-->
            <!--                          :class="[-->
            <!--                            {-->
            <!--                              'unread-notification':-->
            <!--                                notification.read_at === null-->
            <!--                            },-->
            <!--                            {-->
            <!--                              'read-notification': notification.read_at !== null-->
            <!--                            }-->
            <!--                          ]"-->
            <!--                        >-->
            <!--                          <div class="element-notification-content">-->
            <!--                            <div class="no-padding">-->
            <!--                              <div class="box-notification-image">-->
            <!--                                <div class="notification-image">-->
            <!--                                  <progressive-img-->
            <!--                                    :src="-->
            <!--                                      notification.data-->
            <!--                                        ? notification.data.image-->
            <!--                                        : ''-->
            <!--                                    "-->
            <!--                                    fallback="/img/default-avatar.png"-->
            <!--                                  />-->
            <!--                                </div>-->
            <!--                                <div class="notification-type-icon">-->
            <!--                                  <md-icon>notifications </md-icon>-->
            <!--                                </div>-->
            <!--                              </div>-->
            <!--                            </div>-->
            <!--                            <div class="notification-title-layout">-->
            <!--                              <div-->
            <!--                                class="notification-title-text"-->
            <!--                                v-html="-->
            <!--                                  notification.data-->
            <!--                                    ? notification.data.title-->
            <!--                                    : ''-->
            <!--                                "-->
            <!--                              ></div>-->

            <!--                              <p-->
            <!--                                class="notification-time"-->
            <!--                                :class="[-->
            <!--                                  {-->
            <!--                                    'unread-notification-time':-->
            <!--                                      notification.read_at === null-->
            <!--                                  }-->
            <!--                                ]"-->
            <!--                              >-->
            <!--                                {{ notification.created_at | formatTimeAgo }}-->
            <!--                              </p>-->
            <!--                            </div>-->
            <!--                            <div-->
            <!--                              class="md-layout-item md-size-5 md-small-size-5 unread-notification-icon-container"-->
            <!--                            >-->
            <!--                              <div-->
            <!--                                :class="[-->
            <!--                                  {-->
            <!--                                    'unread-notification-icon':-->
            <!--                                      notification.read_at === null ||-->
            <!--                                      notification.read_at === 'undefined'-->
            <!--                                  }-->
            <!--                                ]"-->
            <!--                              ></div>-->
            <!--                            </div>-->
            <!--                          </div>-->
            <!--                        </a>-->
            <!--                      </li>-->
            <!--                    </ul>-->
            <!--                  </drop-down>-->
            <!--                </div>-->
            <!--              </a>-->
            <!--            </li>-->

            <md-list-item :to="{ name: 'ProfileUser' }">
              <i class="material-icons">person</i>
              <p class="hidden-lg hidden-md">Profile</p>
            </md-list-item>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      notifications: [],
      path: "/notifications",
      newNotification: {},
      isFirstTimeInit: true,
      state: null
    };
  },
  mounted() {},
  watch: {},
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.top-navbar {
  z-index: 2;
}

.alert.alert-info:hover {
  background-color: #eeeeee !important;
}

.unread-notification {
  background-color: #eaf3ff;
  color: #050505 !important;
}

.read-notification {
  background: none;
  color: #65676b !important;
}

.item-notification {
  margin: 2px 0;
}

.notification-box {
  display: block !important;
  padding: 10px;

  .md-layout {
    flex-wrap: inherit;
  }
}

.notification-title-text {
  margin: 0;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  word-break: break-word;
}

.notification-time {
  margin: 0;
  font-size: 11px;
}

.notification-button {
  max-height: 400px;
  max-width: 400px;
  overflow-x: hidden;
  overflow-y: auto;

  li a {
    .progressive-image,
    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 5px;
    }
  }
}

.no-padding {
  padding: 0 !important;
}

.notification-title-layout {
  padding-left: 5px;
  padding-right: 0;
  white-space: normal;
}

.element-notification-content {
  min-width: 300px;
  display: grid;
  grid-template-columns: 50px 1fr 20px;
}

//notification type icon
.box-notification-image {
  position: relative;
  display: flex;
  width: 50px;
  height: 50px;

  .notification-image {
    float: left;
    border-radius: 50%;

    img {
      width: 100%;
    }
  }

  .progressive-image {
    overflow: hidden;
    z-index: 5;
    -webkit-box-shadow: 0 16px 38px -12px rgb(0 0 0 / 56%),
      0 4px 25px 0px rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(0 0 0 / 20%);
    box-shadow: 0 16px 38px -12px rgb(0 0 0 / 56%),
      0 4px 25px 0px rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(0 0 0 / 20%);
    -webkit-transition: opacity 300ms linear, -webkit-transform 300ms linear;
    transition: transform 300ms linear, opacity 300ms linear,
      -webkit-transform 300ms linear;
  }
}

.unread-notification-icon-container {
  place-self: center;
  padding-left: 20px !important;
}

.unread-notification-icon {
  width: 10px;
  height: 10px;
  background: #1876f2;
  border-radius: 50%;
}

.unread-notification-time {
  color: #1876f2;
  font-weight: 600;
}

.notification-type-icon {
  padding: 2px;
  position: absolute;
  background: #fff;
  border: 1px solid #1f87fe;
  border-radius: 50%;
  z-index: 5;
  right: 2px;
  bottom: 7px;
  line-height: 14px;

  i {
    font-size: 14px !important;
    color: #fff !important;
    width: 14px;
    min-width: 14px;
    height: 14px;
  }
}

.all-notification {
  justify-content: center;
  font-weight: 600;
  font-size: 18px;
}
</style>
